module.exports = __webpack_public_path__ + "static/media/32.2b15dbc.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/32.wav
// module id = xWXF
// module chunks = 0